export default __webpack_public_path__ + "static/media/image-eye.f47a537e.svg";